import axios from 'axios';
import config from '@/config';
import router from '@/router';
import store from '@/store';

class API {
  constructor() {
    this.backendUrl = config.backendUrl();
  }

  get(url, data, direct) {
    if (!direct) {
      return this.request('get', url, data, direct);
    } else {
      return this.requestOutside('get', url, data);
    }
  }

  post(url, data) {
    return this.request('post', url, data);
  }

  put(url, data) {
    return this.request('put', url, data);
  }

  delete(url, data) {
    return this.request('delete', url, data);
  }

  requestOutside(method, url, data) {
    return axios({
      method,
      url: url,
      data
    });
  }

  request(method, url, data) {
    return axios({
      method,
      url: `${this.backendUrl}${url}`,
      data,
      withCredentials: true
    })
      .then(response => {
        if (response.data.status === 'error' && !response.data.errors) {
          response.data.errors = [];
        }
        return response.data;
      })
      .catch(e => {
        if (e.response.status === 401) {
          store.commit('setCurrentUser', null);
          router.push('/login');
        }

        return e.response.data;
      });
  }
}

export default new API();
